export const EditorMixin = {
    data() {
        return {
            editorConfig: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'direction': 'rtl' }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
                        [{ 'color': [] }, { 'background': [] }],
                        ['link']
                    ]
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/EditorMixin.js